import { useContactManagementTranslation } from '../../ui/hooks';
import { initFeatureFlags } from '@juvare/common-js/feature-flags';
import React from 'react';
import { useSelector } from 'react-redux';
export const ContactManagementConfigContext = React.createContext(undefined);
export const ContactManagementConfigProvider = ({ appName, notificationConfig, accountConfig, accountsTableCustomization, userDirectoryTableCustomization, children, }) => {
    var _a;
    const { ready } = useContactManagementTranslation();
    const userStateResponse = useSelector(getUserStateResponseOptional);
    if (userStateResponse) {
        initFeatureFlags({
            context: Object.assign({ email: userStateResponse.state.email, systemRole: userStateResponse.state.systemRole, environment: userStateResponse.state.environment }, Object.fromEntries(((_a = userStateResponse.state.systemPermissions) !== null && _a !== void 0 ? _a : []).map((permission) => {
                return [`system-permission-${permission}`, true];
            }))),
        });
    }
    else {
        initFeatureFlags({ context: {} });
    }
    React.useEffect(() => {
        const handleTimeout = setTimeout(() => {
            if (!ready) {
                console.warn('Translations were not loaded...');
            }
        }, 10 * 1000);
        return () => clearTimeout(handleTimeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const contactManagementConfig = React.useMemo(() => {
        return {
            appName: appName,
            notificationConfig: notificationConfig,
            accountConfig: accountConfig,
            accountsTableCustomization,
            userDirectoryTableCustomization,
        };
    }, [appName, accountConfig, notificationConfig, accountsTableCustomization, userDirectoryTableCustomization]);
    return (React.createElement(ContactManagementConfigContext.Provider, { value: contactManagementConfig }, ready && children));
};
export function getUserStateResponseOptional(state) {
    var _a;
    return (_a = state.platform.user) === null || _a === void 0 ? void 0 : _a.data;
}
